import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCompass,
    faMagnifyingGlass,
    faMap,
    faTableColumns
} from "@fortawesome/free-solid-svg-icons";
import {AppScreen} from "../app-screen";
import './header.scss';

export type HeaderProps = {
    hasData: boolean,
    showNavigation: boolean,
    activeScreen: AppScreen,
    onShowDashboard: () => void,
    onShowMap: () => void,
    onShowFamilyExplorer: () => void,
    onShowHotspotExplorer: () => void,
    onShowDiscover: () => void
}

export default function Header({
    hasData,
    showNavigation,
    activeScreen,
    onShowDashboard,
    onShowMap,
    onShowFamilyExplorer,
    onShowHotspotExplorer,
    onShowDiscover
}: HeaderProps) {
    return (
        <div className="app-header">
            <div className="app-header__inner">
                <button type="button" className="app-header__brand" onClick={onShowDashboard}>
                    <img src="/assets/birdmap-logo-v2.svg" alt="BirdMap Explorer" className="app-header__logo" />
                </button>
                {showNavigation ?
                    <nav className="app-header__nav" aria-label="Primary navigation">
                        <button
                            type="button"
                            className={`app-header__nav-item ${activeScreen === AppScreen.SelectTimePeriod ? 'is-active' : ''}`}
                            onClick={onShowDashboard}
                        >
                            <FontAwesomeIcon icon={faTableColumns} aria-hidden="true" />
                            Dashboard
                        </button>
                        {hasData ?
                            <>
                            <button
                                type="button"
                                className={`app-header__nav-item ${activeScreen === AppScreen.Map ? 'is-active' : ''}`}
                                onClick={onShowMap}
                            >
                                <FontAwesomeIcon icon={faMap} aria-hidden="true" />
                                Map
                            </button>
                            <button
                                type="button"
                                className={`app-header__nav-item ${activeScreen === AppScreen.FamilyExplorer ? 'is-active' : ''}`}
                                onClick={onShowFamilyExplorer}
                            >
                                <FontAwesomeIcon icon={faMagnifyingGlass} aria-hidden="true" />
                                Family Explorer
                            </button>
                            <button
                                type="button"
                                className={`app-header__nav-item ${activeScreen === AppScreen.HotspotExplorer ? 'is-active' : ''}`}
                                onClick={onShowHotspotExplorer}
                            >
                                <FontAwesomeIcon icon={faMap} aria-hidden="true" />
                                Hotspot Explorer
                            </button>
                            <button
                                type="button"
                                className={`app-header__nav-item ${[AppScreen.Discover, AppScreen.BigYear].includes(activeScreen) ? 'is-active' : ''}`}
                                onClick={onShowDiscover}
                            >
                                <FontAwesomeIcon icon={faCompass} aria-hidden="true" />
                                Discover
                            </button>
                            </> :
                            null
                        }
                    </nav>
                    : null
                }
            </div>
        </div>
    )
}
